export class ContactHdrModel {
  _id?: any;
  uuid: string;
  revision: string;
  status: string;
  vrsn: string;
  username: string;
  type: string;
  first_name: string;
  last_name: string;
  fk_uuid: FkUuid;
  contact_key_uuid: string;
  create_date: Date;
  update_date: Date;
  created_by: string;
  updated_by: string;
}

export class FkUuid {
  tenant_code: string;
  tenant_guid: string;
  contactHdr: string;
  membership: string;
  entity: string;
  loginsubject: string;
}
